import CustomerView from "./CustomerView";
export default CustomerView;